import { HttpResponse } from '@asset-metrix/portal-gateway-client-js';
import { AsyncNotification, Button } from '@asset-metrix/portal-ui';

import i18n from '../i18n/config';

export const MAINTENANCE_NOTIFICATION_ID = 'maintenance-notification-id';

/**
 * Shows a maintenance notification with a reload action button.
 * This notification appears when the application is in maintenance mode (503 errors).
 *
 * @param res - Optional HttpResponse
 * @returns The notification ID for potential updates
 */
export function showMaintenanceNotification(
  res?: HttpResponse<unknown, unknown>
): string | undefined {
  // check if maintenanceMode is enabled
  const isMaintenanceModeEnabled =
    (res?.error as { code: string })?.code === 'maintenance-mode-enabled';

  const message = i18n.t(
    `app.notifications.maintenance.${isMaintenanceModeEnabled ? 'plannedMaintenanceMessage' : 'message'}`
  );

  return AsyncNotification.show(
    {
      title: i18n.t('app.notifications.maintenance.title'),
      message: (
        <div>
          <p>{message}</p>
          <Button
            onClick={() => globalThis.location.reload()}
            style={{ marginTop: '8px' }}
          >
            {i18n.t('app.notifications.maintenance.action')}
          </Button>
        </div>
      ),
      withCloseButton: false,
    },
    'warning',
    { customId: MAINTENANCE_NOTIFICATION_ID }
  );
}
